export const formatLatLon = (lat, lon) => {
  lat = parseFloat(lat).toFixed(5);
  lon = parseFloat(lon).toFixed(5);
  lat = (lat < 0 ? "" : "+") + lat;
  lon = (lon < 0 ? "" : "+") + lon;
  return `${lat}, ${lon}`;
};
